import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M11.27 5.97H4.32v13.883h13.863V12.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.93142 0 0 6.94133 11.251 12.911)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1390DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  })))),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M11.27 5.97H4.32v13.883h13.863V12.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.93142 0 0 6.94133 11.251 12.911)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1390DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  })))),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3.96",
    d: "M21.54 12.94H7.64v27.765h27.726V26.801"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M37.005 7.85s1.666-.679 3.1.755c1.433 1.433.752 3.1.752 3.1L24.24 28.315c-.223.224-.497.39-.798.487l-5.212 1.67 1.67-5.212c.096-.301.264-.575.487-.798L37.005 7.851z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M24.203 28.385s.68-1.666-.753-3.1c-1.434-1.433-3.1-.754-3.1-.754"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(13.8628 0 0 13.8827 21.503 26.823)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1390DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  }))))
};
export var NBY = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});